export const isURL = (href) => Boolean(href?.includes(':'));
export const isLocalURL = (href, target) => Boolean(href && !isURL(href) && (!target || target === '_self'));
export const isHash = (href) => Boolean(href?.startsWith('#'));
export const withoutQuery = (href) => (href || '').replace(/\?.*/, '').replace(/\/$/, '');
export const joinPath = (...path) => path
    .filter(Boolean)
    .join('/')
    .replace(/\/+/g, '/')
    .replace(/^(.+):\//, '$1://')
    .replace(/^file:/, 'file:/')
    .replace(/\/(\?|&|#[^!])/g, '$1')
    .replace(/\?/g, '&')
    .replace('&', '?');
export const hasPrefix = (href, prefix) => Boolean(prefix &&
    href &&
    href.startsWith(prefix) &&
    [prefix === '/', href === prefix, href[prefix.length] === '/'].some(Boolean));
//# sourceMappingURL=url.js.map